module.exports = __webpack_public_path__ + "img/icon-instagram.286a00d1.svg";